var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"id":"tag","href":_vm.tag.link,"title":_vm.tag.name,"target":"_blank"}},[_vm._v("\n  "+_vm._s(_vm.tag.name)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }